
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"300","height":"300"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{attrs:{"data-name":"😎","fill":"#707070","font-size":"20","font-family":"AppleColorEmoji, Apple Color Emoji"}},[_c('tspan',{attrs:{"x":"0","y":"22"}},[_v('😎')])])])
          )
        }
      }
    